export default "__VITE_ASSET__24c27250__"